<i-feather class="user-muted-icon" *ngIf="user.muted" [name]="'mic-off'"></i-feather>
<div class="stream-user-wrap">
  <div class="stream-user--panel">
            <span *ngIf="user.userId !== 'self'" (click)="toggleMuteUser.emit(user.userId)" class="steam-mute pointer">
              <i-feather [name]="user.muted ? 'mic' : 'mic-off'"></i-feather>
            </span>
  </div>
  <!--<h4>{{user.userId}}</h4>-->
  <div class="stream-user--bg"
       [style.background-image]="'url(' + chat.avatar +')'" >
  </div>
  <div *ngIf="webrtcService.usersVideoList?.length > 1" class="stream-user--avatar d-flex align-items-center justify-content-center">
    <app-avatar
      [id]="chat?.id"
      [type]="chat.type"
      [avatar]="chat.avatar"
      [avatarFileId]="chat.avatar_file_id"
      [avatarFileUniqueId]="chat.avatar_file_unique_id"
      class="avatar avatar-lg"
    ></app-avatar>
  </div>
  <video [class.bg--avatar]="!!chat.avatar" autoplay
         (click)="webrtcService.videoStreamInit(video, user)" playsinline
         [muted]="user.userId === 'self'"
         [attr.muted]="user.muted"
         #video
  ></video>

</div>
